var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { E_INFO_MESSAGE_SEVERITY, InfoMessage } from 'src/ui/components/InfoMessage/InfoMessage';
import { DropDownSection } from 'src/ui/components/DropDown/DropDownSection';
import styles from './UserAlertItem.module.scss';
export var UserAlertItem = function (props) {
    var _a;
    var title = props.title, errorMessages = props.errorMessages, warningMessages = props.warningMessages;
    var haveErrorMessages = errorMessages.length > 0;
    var haveWarningMessages = warningMessages.length > 0;
    var dropdownClass = classNames((_a = {},
        _a[styles.UserAlertItemError] = haveErrorMessages,
        _a[styles.UserAlertItemWarning] = haveWarningMessages,
        _a));
    return (_jsxs(DropDownSection, __assign({ label: title, className: dropdownClass }, { children: [haveErrorMessages && _jsx(InfoMessage, { severity: E_INFO_MESSAGE_SEVERITY.ERROR, messages: errorMessages }), haveWarningMessages && _jsx(InfoMessage, { severity: E_INFO_MESSAGE_SEVERITY.WARNING, messages: warningMessages })] })));
};
